<template>
    <div
        class="player-level"
    >
        <div class="title">{{ $t('sidebar.level') }}:</div>
        <div
            class="value"
            :style="{
                'background-color': getLevelColor(getPlayerLevel),
                'color': getPlayerLevel === 'Bronze' ? '#fff' : '#000'
            }"
        >{{ getPlayerLevel }}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isTooltipVisible: false
            }
        },
        computed: {
            player() {
                return this.$store.getters.getCurrentUser
            },
            getTotalScore() {
                return this.player?.totalScore
            },
            getPlayerLevel() {
                if (this.getTotalScore >= 700) {
                    return 'Diamond'
                } else if (this.getTotalScore >= 500) {
                    return 'Platinum'
                } else if (this.getTotalScore >= 300) {
                    return 'Gold'
                } else if (this.getTotalScore >= 100) {
                    return 'Silver'
                } else if (this.getTotalScore >= 0) {
                    return 'Bronze'
                } else {
                    return ''
                }
            }
        },
        methods: {
            getLevelColor(level) {
                switch (level) {
                case 'Bronze':
                    return '#CD7F32'
                case 'Silver':
                    return '#C0C0C0'
                case 'Gold':
                    return '#FFD700'
                case 'Platinum':
                    return '#E5E4E2'
                case 'Diamond':
                    return '#B9F2FF'
                default:
                    return ''
                }
            }
        }
    }
</script>

<style scoped>
.player-level {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.5rem 0;
    color: var(--sidebar-text);
}

.player-level .value {
    height: 30px;
    padding: 0 0.5rem;
    border-radius: 1.25rem;
    display: grid;
    place-items: center;
}

</style>
